import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "fullWidth", "color", "label", "bottomLabel", "error", "warning", "success", "maskProps", "inputRef", "focused", "labelProps", "fieldProps", "containerProps", "type", "value", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from 'react';
import { Box, Grid, InputAdornment } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useDeviceSize } from '@hooks/useDeviceSize';
import { DayPickerActionBarComponent } from '@elements/form/fields/day-picker-field/day-picker-action-bar.component';
import { TextMask } from '@elements/form/fields/text-mask';
import { Icon } from '@elements/icon';
import { IconButton } from '@elements/icon-button';
import { colors, pxToRem } from '@themes';
import { StyledFormControl, StyledFormHelperErrorText, StyledFormHelperSuccessText, StyledFormHelperText, StyledFormHelperWarningText, StyledInputBase, StyledPickersLayout, StyleFormHelperWrapper } from './day-picker-field.styles';
import Calendar from '@images/calendar.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DayPickerField = function DayPickerField(_ref) {
  var name = _ref.name,
    fullWidth = _ref.fullWidth,
    color = _ref.color,
    label = _ref.label,
    bottomLabel = _ref.bottomLabel,
    error = _ref.error,
    warning = _ref.warning,
    success = _ref.success,
    maskProps = _ref.maskProps,
    inputRef = _ref.inputRef,
    focused = _ref.focused,
    labelProps = _ref.labelProps,
    fieldProps = _ref.fieldProps,
    containerProps = _ref.containerProps,
    type = _ref.type,
    value = _ref.value,
    _onChange = _ref.onChange,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isShowButtons = _useState4[0],
    setIsShowButtons = _useState4[1];
  var inputName = name && "".concat(name, "-textfield");
  var _useDeviceSize = useDeviceSize(),
    mobile = _useDeviceSize.mobile;
  var isError = !!error;
  var isWarning = !!warning;
  var isSuccess = !!success;
  var literalProps = {
    htmlFor: inputName,
    id: inputName,
    errorId: inputName && "".concat(inputName, "-error-text")
  };
  var TextFieldMaskProps = maskProps ? {
    inputComponent: TextMask,
    inputProps: maskProps
  } : {};
  var parsedValue = !value ? null : value;
  var handleOpen = function handleOpen(event) {
    event === null || event === void 0 || event.stopPropagation();
    setIsOpen(function (prevState) {
      return !prevState;
    });
  };
  return /*#__PURE__*/_jsx(StyledFormControl, {
    error: isError,
    fullWidth: fullWidth,
    focused: focused,
    children: /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
      container: true,
      rowSpacing: 0.5,
      columnSpacing: 2,
      alignItems: "center"
    }, containerProps), {}, {
      children: /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        flex: "1 1"
      }, fieldProps), {}, {
        children: /*#__PURE__*/_jsxs(Box, {
          position: "relative",
          children: [/*#__PURE__*/_jsx(LocalizationProvider, {
            dateAdapter: AdapterMoment,
            adapterLocale: "ru",
            children: /*#__PURE__*/_jsx(StyledInputBase, _objectSpread(_objectSpread({
              error: isError,
              id: literalProps.id,
              "aria-describedby": inputName,
              views: ['month', 'year', 'day'],
              name: name,
              fullWidth: fullWidth,
              open: isOpen,
              color: color,
              onChange: function onChange(e) {
                if (_onChange) {
                  _onChange(e);
                }
              },
              onViewChange: function onViewChange(view) {
                if (view !== 'day') {
                  setIsShowButtons(false);
                } else {
                  setIsShowButtons(true);
                }
              },
              onClose: handleOpen,
              label: label,
              variant: "outlined",
              value: parsedValue,
              slots: {
                layout: StyledPickersLayout,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                actionBar: function actionBar(props) {
                  return mobile ? /*#__PURE__*/_jsx(DayPickerActionBarComponent, _objectSpread(_objectSpread({}, props), {}, {
                    isShowButtons: isShowButtons,
                    handleOpen: handleOpen
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    ,
                    value: parsedValue
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    ,
                    onChange: _onChange
                  })) : null;
                }
              },
              slotProps: {
                desktopPaper: {
                  sx: {
                    background: colors.blackSecondary,
                    borderRadius: pxToRem(28),
                    boxShadow: 'none'
                  }
                },
                mobilePaper: {
                  sx: {
                    backgroundColor: 'unset',
                    borderRadius: pxToRem(28)
                  }
                },
                dialog: {
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    backdropFilter: 'blur(6px)'
                  }
                },
                actionBar: {
                  actions: ['accept', 'cancel']
                },
                textField: {
                  InputProps: {
                    endAdornment: /*#__PURE__*/_jsx(InputAdornment, {
                      position: "end",
                      children: /*#__PURE__*/_jsx(IconButton, {
                        onClick: !mobile ? handleOpen : undefined,
                        children: /*#__PURE__*/_jsx(Icon, {
                          src: Calendar,
                          width: 28,
                          height: 28
                        })
                      })
                    })
                  }
                },
                field: {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  onFocus: restProps.onFocus,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  onBlur: restProps.onBlur,
                  onClick: mobile ? handleOpen : undefined
                }
              }
            }, TextFieldMaskProps), restProps))
          }), isError && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperErrorText, {
              id: literalProps.errorId,
              children: error
            })
          }), isWarning && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperWarningText, {
              id: literalProps.errorId,
              children: warning
            })
          }), isSuccess && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperSuccessText, {
              id: literalProps.errorId,
              children: success
            })
          }), bottomLabel && !isError && !isWarning && !isSuccess ? /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperText, {
              children: bottomLabel
            })
          }) : null]
        })
      }))
    }))
  });
};
export { DayPickerField };